import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${(props) => props.background};
`;

/* SEM `flex: 1`. Este bloco vive dentro de um ScrollView: com flex 1 ele era
   dimensionado pela ALTURA VISÍVEL da tela em vez de crescer com o conteúdo, e
   tudo o que passasse disso ficava cortado — no celular o formulário e a prévia
   sumiam da metade para baixo, com poucos pixels de rolagem. Altura automática
   deixa o ScrollView fazer o trabalho dele. */
export const ContainerLayout = styled.View`
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  padding: 24px;
`;

export const ContainerInputs = styled.View`
  width: 65%;
`;

export const ContainerMockup = styled.View`
  width: 35%;
`;

/* `Input`, `ButtonContainer`, `ErrorMessage`, `CharacterCount` e `InfoMessage`
   viviam aqui e foram removidos: a tela passou a usar AdminInput, SectionCard e
   os textos/botões do padrão do painel, definidos no StyleSheet da própria
   tela. */
